/* W72 STEP 5 (1) — WHICH VIEW A SHELF OPENS IN: list or grid.
 *
 * His note, 2026-09-25 ~07:05: *"we need in the workout builder left in exercise list a grid view too with 2
 * exercises each row … And a button same line of most recent text but right, if list & grid selecting"*. ONE
 * component draws the exercise shelf on the Library's Exercises page AND in the builder's library pane
 * (`components/ExerciseShelf.tsx`), so the two cannot drift.
 *
 * ⚠️ EACH SURFACE REMEMBERS ITS OWN VIEW. A coach who browses the Library as pictures and builds from a list
 * has two answers, and one shared key would make the page's choice flip the pane. The page's key is the one
 * the copied Library already wrote (`ht-exercises-view`), so a coach's stored choice survives this change.
 *
 * ⚠️ `?ht-view=list|grid` PINS IT, above storage, so a still can show either view without writing a browser's
 * store — the `?ht-theme=` idiom. It is read off `location.search` (the part before the hash).
 */
export type ShelfView = "list" | "grid";
export type ShelfSurface = "exercises" | "builderPane";

export const SHELF_VIEWS: readonly ShelfView[] = ["list", "grid"];

/** The browser-store key per surface — never shared. */
export function storageKeyFor(surface: ShelfSurface): string {
  return surface === "exercises" ? "ht-exercises-view" : "ht-builder-pane-view";
}

/** W140 — the surface's choice in the coach's `viewPrefs` (its flat `storageKeyFor` key is the pre-W140 fallback). */
export function prefKeyFor(surface: ShelfSurface): "shelfExercises" | "shelfBuilderPane" {
  return surface === "exercises" ? "shelfExercises" : "shelfBuilderPane";
}

/** `?ht-view=` from a `location.search` string, or null when absent or not one of the two words. */
export function pinnedView(search: string): ShelfView | null {
  const v = new URLSearchParams(search).get("ht-view");
  return v === "list" || v === "grid" ? v : null;
}

/** The view a surface opens in: the pin, else what the surface stored, else LIST (the default both had). */
export function initialView(search: string, stored: string | null): ShelfView {
  return pinnedView(search) ?? (stored === "grid" ? "grid" : "list");
}
